import Vue from 'vue';

Vue.component('car-showcase-slider-component', {
    props: {
        classOfOverflownElement: {
            type: String,
            default: '',
        },

        classOfElementToScroll: {
            type: String,
            default: '',
        },
        visibleClass: {
            type: String,
        },
    },

    data() {
        return {
            timeout: null,

            overflownElement: null,
            isSideOverlayVisible: false,

            elementToScroll: null,
            allCarBlocks: null,
            showArrows: true,
            isPrevButtonVisible: false,
            isNextButtonVisible: true,

            nextButton: null,
            prevButton: null,

            isScrollNextDisabled: false,
            isScrollPrevDisabled: true,

            oneCard: null,
            sliderWrapper: null,

            dragged: false,
            scrollLeft: 0,
            startX: 0,

            carImages: [],
        };
    },

    computed: {
        toggleBorderLeftVisabilityClass() {
            return this.isPrevButtonVisible && this.showArrows
                ? 'carshowcase__slider__container--border-left'
                : '';
        },
    },

    watch: {
        nextButton(newNextButton) {
            if (!newNextButton) return;
            newNextButton.addEventListener('click', this.toggleScrollNext);
        },

        prevButton(newPrevButton) {
            if (!newPrevButton) return;
            newPrevButton.addEventListener('click', this.toggleScrollPrev);
        },
    },

    destroyed() {
        this.nextButton.removeEventListener('click', this.toggleScrollNext);
        this.prevButton.removeEventListener('click', this.toggleScrollPrev);
        this.elementToScroll.removeEventListener(
            'mousewheel',
            this.handleManualScroll,
        );
        this.elementToScroll.removeEventListener(
            'touchmove',
            this.handleManualScroll,
        );
        this.elementToScroll.removeEventListener(
            'scroll',
            this.handleManualScroll,
        );
        window.removeEventListener('resize', this.handleResize);
    },

    created() {
        window.addEventListener('resize', this.handleResize);
    },

    mounted() {
        this.overflownElement = document.querySelector(
            `.${this.classOfOverflownElement}`,
        );
        this.nextButton = document.getElementById('slider-next');
        this.prevButton = document.getElementById('slider-prev');
        this.elementToScroll = document.getElementsByClassName(
            `${this.classOfElementToScroll}`,
        )[0];
        this.elementToScroll.addEventListener(
            'mousewheel',
            this.handleManualScroll,
        );
        this.elementToScroll.addEventListener(
            'touchmove',
            this.handleManualScroll,
        );
        this.elementToScroll.addEventListener(
            'scroll',
            this.handleManualScroll,
        );
        this.elementToScroll.addEventListener('mousemove', this.mouseMove);
        this.elementToScroll.addEventListener('mousedown', this.mouseIsDown);
        this.elementToScroll.addEventListener('mouseup', this.mouseUp);
        this.elementToScroll.addEventListener('mouseleave', this.mouseLeave);
        this.allCarBlocks = document.getElementsByClassName(
            'carshowcase__container-block__card',
        );

        this.oneCard = document.getElementsByClassName(
            'carshowcase__container-block__card',
        )[0];

        this.sliderWrapper = document.getElementsByClassName(
            'carwhowcase__slider-wrapper',
        )[0];

        this.carImages = document.getElementsByClassName(
            'carshowcase__slider__container__image',
        );

        this.checkArrowVisibility();
    },

    methods: {
        handleResize() {
            this.checkArrowVisibility();
        },

        checkArrowVisibility() {
            const widthOfAllCars =
                this.oneCard.clientWidth * this.allCarBlocks.length;

            if (widthOfAllCars < this.sliderWrapper.clientWidth - 100) {
                this.showArrows = false;
                this.elementToScroll.style.width = '100%';
            } else {
                this.showArrows = true;

                this.handleManualScroll();
            }
        },

        handleManualScroll() {
            this.handleDisableScrollNext();
            this.handleDisableScrollPrev();
        },

        toggleScrollNext() {
            if (!this.elementToScroll) return;
            if (this.isScrollPrevDisabled) this.isScrollPrevDisabled = false;
            this.handleDisableScrollNext(true);

            this.elementToScroll.scrollBy({
                left: this.oneCard.clientWidth,
                behavior: 'smooth',
            });
        },

        toggleScrollPrev() {
            if (!this.elementToScroll) return;
            if (this.isScrollNextDisabled) this.isScrollNextDisabled = false;

            this.handleDisableScrollPrev(true);

            this.elementToScroll.scrollBy({
                left: -this.oneCard.clientWidth,
                behavior: 'smooth',
            });
        },

        handleDisableScrollNext(isClicked = false) {
            const lastElementRect =
                this.allCarBlocks[
                    this.allCarBlocks.length - 1
                ].getBoundingClientRect();

            const visibleCarsOnView =
                this.sliderWrapper.clientWidth / this.oneCard.clientWidth;

            const visibleOffest =
                visibleCarsOnView * this.oneCard.clientWidth + 130;

            if (isClicked) {
                this.isScrollNextDisabled =
                    lastElementRect.right - this.oneCard.clientWidth - 130 <
                    this.overflownElement.clientWidth;
            } else {
                this.isScrollNextDisabled =
                    lastElementRect.right - visibleOffest < 0;
            }

            this.isNextButtonVisible = !this.isScrollNextDisabled;

            this.isPrevButtonVisible = true;
        },

        handleDisableScrollPrev(isClicked = false) {
            const firstElementRect =
                this.allCarBlocks[0].getBoundingClientRect();

            if (isClicked) {
                this.isScrollPrevDisabled = firstElementRect.right >= 0;
            } else {
                this.isScrollPrevDisabled =
                    firstElementRect.right - this.oneCard.clientWidth + 130 > 0;
            }

            if (this.isScrollPrevDisabled) this.isPrevButtonVisible = false;
        },

        mouseIsDown(e) {
            this.dragged = true;
            this.startX = e.pageX - this.elementToScroll.offsetLeft;
            this.scrollLeft = this.elementToScroll.scrollLeft;
            this.elementToScroll.style.scrollSnapType = 'none';
        },

        mouseUp(e) {
            this.dragged = false;
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.elementToScroll.style.scrollSnapType = 'both mandatory';
                this.setImagesPointerEvents('auto');
            }, 150);
        },

        mouseLeave(e) {
            this.dragged = false;
            this.elementToScroll.style.scrollSnapType = 'both mandatory';

            this.setImagesPointerEvents('auto');
        },

        mouseMove(e) {
            if (!this.dragged) return;

            e.preventDefault();
            //Move horizontally
            const x = e.pageX - this.elementToScroll.offsetLeft;
            const walkX = x - this.startX;
            this.elementToScroll.scrollLeft = this.scrollLeft - walkX;

            this.setImagesPointerEvents('none');
        },

        setImagesPointerEvents(pointerEvent) {
            for (let i = 0; i < this.carImages.length; i++) {
                this.carImages[i].style.pointerEvents = pointerEvent;
            }
        },
    },
});
